
export default {
  name: 'TitBar'
}
